import { useState } from "react";

import type { Panel } from "../panels";

interface PanelState {
	open: Panel | null;
	/** Still sliding shut. Only closes the user asks for animate, not ones caused by the viewport crossing a breakpoint. */
	closing: Panel | null;
}

export function usePanels() {
	const [{ open, closing }, setState] = useState<PanelState>({ open: null, closing: null });

	const show = (pick: (current: Panel | null) => Panel | null) =>
		setState((state) => {
			const next = pick(state.open);
			return next === state.open ? state : { open: next, closing: state.open ?? state.closing };
		});

	return {
		openPanel: open,
		closingPanel: closing,
		toggle: (panel: Panel) => show((current) => (current === panel ? null : panel)),
		close: (panel: Panel) => show((current) => (current === panel ? null : current)),
		closeAll: () => show(() => null),
		finishClosing: () => setState((state) => ({ ...state, closing: null })),
	};
}
